import axios from "axios";
import { getHeaders, getURl } from "./core";

let url = `${getURl()}/nssf_setting/v1`;

export function getNSSF() {
    return axios({
        method: 'GET',
        headers: getHeaders(),
        url: `${url}/detail`
    });
}

export function updateNSSF(data) {
    return axios({
        method: 'PUT',
        headers: getHeaders(),
        url: `${url}/update`,
        data
    });
}

export function updateSeniorityAndSeverancePay(data) {
    return axios({
        method: 'PUT',
        headers: getHeaders(),
        url: `${url}/update/seniority_severance`,
        data
    });
}